export const minSearchLength = 3;

export function getFormattedSearchValue(unformattedSearch: string) {
  // Remove whitespaces and asterisks from the beginning and end of the string
  return unformattedSearch.trim().replace(/(^[\s*]+)|([\s*]+$)/g, '');
}
